<template>
  <div class="credits-page">
    <div class="page-header">CREDITS</div>
    <div v-for="person in team" :key="person.name" class="rollcall">
      <div class="person">
        <div class="person-name">{{ person.name }}</div>
        <div class="person-role">{{ person.role }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CreditsPage",
  data: () => ({
    team: [
      {
        name: "Kam Seng Aung",
        role: "Audio Field Recordings",
      },
      {
        name: "Ja San Pan",
        role: "Audio Field Recordings",
      },

      {
        name: "Thun Bohn Naing",
        role: "English and Myanmar Text",
      },
      {
        name: "Stefanie Chan",
        role: "German Text",
      },
      {
        name: "Louziness",
        role: "UI Design",
      },
      {
        name: "Hae Thaw Htet",
        role: "Photos",
      },
      {
        name: "Emily Fishbein",
        role: "Photos",
      },

      {
        name: "Samuel Cho",
        role: "Site Development/Concept",
      },
    ],
  }),
};
</script>

<style>
.credits-page {
  padding: 12vh 5vw;
}

.person {
  padding: 2vh 0;
  font-size: 1.25em;
  color: white;
}

.person-name {
  font-weight: 700;
  color: white;
}
</style>